import HttpRequest from "@api/httpRequest";
import {RequestData} from "@models/axios";
import getPropByString from "@utils/get";

const getUrl = (): string => {
    return `/resources`
};


function api() {
    return {
        getList: (data: RequestData) => {
            const {params = {}} = data;
            return HttpRequest.get(getUrl(), {
                params: params
            });
        },

        delete: (data: RequestData) => {
            const url = `${getUrl()}/${getPropByString(data, "params.id")}`;
            return HttpRequest.delete(url, {});
        }
    };
}

export default api();
